import { normalizeName } from "./electoral-results";

// District prefix patterns
const DISTRITO_PREFIX_REGEX =
  /^(?:DISTRITO|PROVINCIA|PROV\.?|PCIA\.?)(?:\s+DE)?\s+/;

// Province name to ID mappings
export const DISTRITO_ENTRIES: Array<[string, string[]]> = [
  ["01", ["CAPITAL FEDERAL", "CABA", "CIUDAD AUTONOMA DE BUENOS AIRES"]],
  ["02", ["BUENOS AIRES", "PBA"]],
  ["03", ["CATAMARCA"]],
  ["04", ["CORDOBA", "CÓRDOBA"]],
  ["05", ["CORRIENTES"]],
  ["06", ["CHACO"]],
  ["07", ["CHUBUT"]],
  ["08", ["ENTRE RIOS", "ENTRE RÍOS"]],
  ["09", ["FORMOSA"]],
  ["10", ["JUJUY"]],
  ["11", ["LA PAMPA"]],
  ["12", ["LA RIOJA"]],
  ["13", ["MENDOZA"]],
  ["14", ["MISIONES"]],
  ["15", ["NEUQUEN", "NEUQUÉN"]],
  ["16", ["RIO NEGRO", "RÍO NEGRO"]],
  ["17", ["SALTA"]],
  ["18", ["SAN JUAN"]],
  ["19", ["SAN LUIS"]],
  ["20", ["SANTA CRUZ"]],
  ["21", ["SANTA FE"]],
  ["22", ["SANTIAGO DEL ESTERO"]],
  ["23", ["TUCUMAN", "TUCUMÁN"]],
  ["24", ["TIERRA DEL FUEGO", "TIERRA DEL FUEGO AIAS"]],
];

// Build lookup map
const DISTRITO_ID_BY_ALIAS = new Map<string, string>();

for (const [id, aliases] of DISTRITO_ENTRIES) {
  for (const alias of aliases) {
    DISTRITO_ID_BY_ALIAS.set(normalizeName(alias), id);
  }
}

/**
 * Resolve a district name to its ID
 */
export function resolveDistritoId(value?: string | null): string | null {
  if (!value) return null;

  const normalized = normalizeName(value);
  const stripped = normalized.replace(DISTRITO_PREFIX_REGEX, "");
  const candidates = new Set([normalized, stripped]);

  // Try exact matches first
  for (const candidate of candidates) {
    const match = DISTRITO_ID_BY_ALIAS.get(candidate);
    if (match) return match;
  }

  // Try partial matches
  for (const candidate of candidates) {
    for (const [alias, id] of DISTRITO_ID_BY_ALIAS.entries()) {
      if (alias.includes(candidate) || candidate.includes(alias)) {
        return id;
      }
    }
  }

  return null;
}

/**
 * Get the canonical name for a district ID
 */
export function getDistritoName(id: string): string | null {
  const entry = DISTRITO_ENTRIES.find(([entryId]) => entryId === id);
  return entry ? (entry[1][0] as string) : null;
}

export const extractDigits = (value?: string | null) => {
  if (!value) return "";
  const matches = value.match(/\d+/g);
  return matches ? matches.join("") : "";
};

/**
 * Normalize mesa ID by extracting and converting to number
 */
export const normalizeMesaId = (value?: string | null) => {
  return value;
};

/**
 * Normalize circuito ID by extracting and padding to 5 digits
 */
export const normalizeCircuitoId = (value?: string | null) => {
  if (!value) return "";
  // Extract only numeric digits, ignoring letters
  const digits = value.match(/\d+/g);
  if (!digits) return "";
  const combinedDigits = digits.join("");
  if (!combinedDigits) return "";
  return combinedDigits.padStart(5, "0");
};
